import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withPermission, Roles } from "../../../util/PermissionProvider";
import ProgrammeCategoryPage from "./ProgrammeCategoryPage";
import ProgrammeCategoryEditPage from "./ProgrammeCategoryPage/editPage";
import ProgrammeListingPage from "./ProgrammeListingPage";
import ProgrammeEditPage from "./ProgrammeEditPage";


export default function ProgrammePages(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        path={`${match.url}/programme/:id`}
        component={withPermission(
          ProgrammeEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        exact
        path={`${match.url}/programme`}
        component={withPermission(
          ProgrammeListingPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/programme-category/:id`}
        component={withPermission(
          ProgrammeCategoryEditPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/programme-category`}
        component={withPermission(
          ProgrammeCategoryPage,
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR, Roles.HKIFF_VIEWER],
          [Roles.SUPERADMIN, Roles.HKIFF_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
